const store = {
    namespaced: true,
    state() {
        return {
            terms: null,
        }
    },
    getters: {
        terms: (state) => state.terms,
    },
    mutations: {
        GET_TERMS: (state, items) => state.terms = items,
    },
    actions: {
        setTerms: ({ commit }, items) => commit('GET_TERMS', items),
        fetchTerms: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'GET',
                    url: `/api/static-content/2/`,
                })
                commit('GET_TERMS', res.data)
            } catch (error) {
                console.dir(error)
            }
        },
    }
}

export default store